export default __webpack_public_path__ + "static/media/remove-user.32fe31ff.svg";